import LoadingButton from '@mui/lab/LoadingButton';
import {
    DialogContent,
    Grid,
    TextField,
} from '@mui/material';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import { useEffect, useState } from 'react';
import server from '../../../global/server';
import useHandleErrors from '../../../hooks/useHandleErrors';
import ButtonVerify from './ButtonVerify';

export default ({ data, mutate, close }) => {
    const { enqueueSnackbar } = useSnackbar();
    const [errs, setErrs] = useState();
    useHandleErrors(errs);

    const {
        values, errors, dirty, handleChange, handleBlur,
        handleSubmit, isSubmitting, setValues, resetForm,
    } = useFormik({
        initialValues: {
            profession: '',
            education: '',
            residence: '',
            email: '',
            instagram: '',
            short_description: '',
        },
        onSubmit: async (values, { setSubmitting }) => {
            try {
                setSubmitting(true);
                await server.put(`/account`, {
                    email: values.email,
                    profession: values.profession,
                    education: values.education,
                    residence: values.residence,
                    instagram: values.instagram,
                    description: values.short_description,
                });
                enqueueSnackbar('Perfil de anfitrião atualizado', { variant: 'success' });
                setSubmitting(false);
                mutate();
            } catch (error) {
                setSubmitting(false);
                setErrs(error);
            }
        },
    });

    useEffect(() => {
        if (data) {
            const vals = {
                profession: data.profession || '',
                education: data.education || '',
                residence: data.residence || '',
                email: data.email || '',
                instagram: data.instagram || '',
                short_description: data.description || '',
            };
            setValues(vals, true);
            resetForm({ values: vals });
        }
    }, [data]);

    return (
        <form onSubmit={handleSubmit}>
            <DialogContent>
                <Grid container rowSpacing={2}>
                    {/* Aprovar/remover anfitriao tambem aqui: e a aba que o admin
                        abre para julgar o anfitriao */}
                    <Grid item xs={12}>
                        <ButtonVerify data={data} mutate={mutate} close={close} />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Profissão"
                            name="profession"
                            value={values.profession}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Formação"
                            name="education"
                            value={values.education}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Cidade-UF"
                            name="residence"
                            value={values.residence}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="E-mail"
                            name="email"
                            value={values.email}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Instagram"
                            name="instagram"
                            value={values.instagram}
                            onChange={handleChange}
                            onBlur={handleBlur}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            variant="outlined"
                            fullWidth
                            size="small"
                            label="Descrição"
                            name="short_description"
                            value={values.short_description}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            multiline
                            minRows={2}
                        />
                    </Grid>
                    <Grid item xs={12} sx={{ mt: 1 }}>
                        <LoadingButton
                            type="submit"
                            fullWidth
                            loading={isSubmitting}
                            variant="contained"
                            disabled={!dirty || isSubmitting}
                            sx={{
                                bgcolor: '#006a61',
                                textTransform: 'none',
                                fontWeight: 600,
                                borderRadius: '8px',
                                '&:hover': { bgcolor: '#005a52' },
                            }}
                        >
                            Salvar perfil de anfitrião
                        </LoadingButton>
                    </Grid>
                </Grid>
            </DialogContent>
        </form>
    );
};
